import Landing from './Landing';
import Confirmation from './Confirmation';

const Default = {
  Landing,
  Confirmation,
};

export default Default;
